import { createFileRoute } from '@tanstack/react-router';
import { GapsPage } from '../features/gaps/GapsPage';

export const Route = createFileRoute('/gaps')({
  component: GapsPage,
});
